import getConfig from 'next/config';
import { graphqlFetcher } from '../api';
import processLoginToken from '../../utils/processLoginToken';
import { log_error } from '../../utils/logger';
import { cleanPhoneNumber } from '../phoneNumber';
import { emailLoginMutation, firebaseLoginMutation, googleLoginMutation } from './mutationGraphql';

const { GATEKEEPER_URL } = getConfig().publicRuntimeConfig;

export interface IGoogleLoginPayload {
  authCode: string;
  redirectUri: string;
}

export interface ILoginHandlerPayload {
  type: string;
  emailLogin?: {
    email: string;
    password: string;
  };
  googleLogin?: IGoogleLoginPayload;
  firebaseLogin?: {
    uid: string;
  };
}

export const LoginAPIService = async (payload: ILoginHandlerPayload) => {
  let query;
  let variables;

  if (payload.type === 'emailLogin') {
    query = emailLoginMutation;
    variables = {
      username: cleanPhoneNumber(payload[payload.type].email, false),
      password: payload[payload.type].password,
    };
  }
  if (payload.type === 'googleLogin') {
    query = googleLoginMutation;
    variables = {
      authCode: payload[payload.type].authCode,
      redirectUri: payload[payload.type].redirectUri,
    };
  }

  if (payload.type === 'firebaseLogin') {
    query = firebaseLoginMutation;
    variables = {
      uid: payload[payload.type].uid,
    };
  }

  const graphConfig = {
    query: query,
    variables: variables,
    targetURL: GATEKEEPER_URL,
    options: {
      method: 'POST',
    },
  };

  try {
    const { data } = await graphqlFetcher(
      query,
      variables,
      graphConfig.targetURL,
      graphConfig.options
    );

    if (data && data.login) {
      return processLoginToken(data.login);
    }
    if (data && data.googleLogin) {
      return processLoginToken(data.googleLogin);
    }
    if (data && data.firebaseLoginByUid) {
      return processLoginToken(data.firebaseLoginByUid);
    }
    return false;
  } catch (err) {
    log_error(payload.type, 'error', err);
    return false;
  }
};

export default LoginAPIService;
